<template>
  <div class="content">
    <div class="body" :loading="loading">
      <div class="search-box min">
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="formList.companyId" clearable filterable @on-change="companyChange">
            <Option v-for="(item, index) in companyList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">保险产品</span>
          <Select v-model="formList.id" clearable filterable>
            <Option v-for="(item, index) in productList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">产品类型</span>
          <Select v-model="formList.productType" clearable>
            <Option v-for="(txt, value) in productTypeList" :value="value" :key="value">{{ txt }}</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="handleSearch()">查询</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost @click="handleExport()">导出</Button>
        </div>
      </div>
      <div class="tableBox">
        <loading :isShow="loading" />
        <Table ref="selection" :columns="columns" :data="dataList">
          <template slot-scope="{ row, index }" slot="action">
            <div class="bjbtn" v-if="isIFA" @click="toCommission(row)">{{ isIFA ? '佣金详情' : '查看积分' }}</div>
            <div class="bjbtn" @click="toDetailPage(row)">详情</div>
            <div class="bjbtn" @click="downloadFile(row)">下载</div>
          </template>
        </Table>
      </div>
      <div class="pageBox">
        <Page :total="allData.total" :current="allData.current" :page-size="allData.size" show-total @on-change="pageChange" style="text-align: center" />
      </div>
    </div>
  </div>
</template>
<script>
let vm;
export default {
  computed: {
    isIFA() {
      return this.userInfo?.isIFA;
    }
  },
  data: () => ({
    companyList: [],
    productList: [],
    productTypeList: JSON.parse(localStorage.dic)['PRODUCT_TYPE2'], // 产品类型
    vipLevelList: JSON.parse(localStorage.dic)['VIP_LEVEL'], // 等级
    productStatusList: [
      {
        key: '0',
        label: '在售'
      },
      {
        key: '1',
        label: '停售'
      }
    ],
    formList: {
      companyId: '',
      id: '',
      productType: ''
    },
    columns: [
      {
        title: '保险公司',
        key: 'companyName',
        minWidth: 100,
        align: 'center'
      },
      {
        title: '产品名称',
        key: 'name',
        minWidth: 100,
        align: 'center'
      },
      {
        title: '产品类型',
        key: 'productType',
        minWidth: 100,
        align: 'center',
        render(h, { row }) {
          return <span>{vm.productTypeList[row.productType]}</span>;
        }
      },
      {
        title: '状态',
        key: 'status',
        minWidth: 100,
        align: 'center',
        render(h, { row }) {
          if (row.status == 1) {
            return (
              <Tag checkable color="error">
                停售
              </Tag>
            );
          } else if (row.status == 0) {
            return (
              <Tag checkable color="success">
                在售
              </Tag>
            );
          }
        }
      },
      {
        title: '创建时间',
        key: 'createTime',
        align: 'center',
        minWidth: 100,
        render: (h, params) => {
          return h('div', params.row.createTime.split(' ')[0]);
        }
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        width: 190
      }
    ],
    entityData: {
      id: '', // id
      companyId: '', // 保司id
      name: '', // 产品名称
      code: '', // 产品编码
      productType: '', // 产品类型
      status: '', // 产品状态
      information: '' //产品资料
    },
    detailModal: false,
    pageNo: 1,
    pageSize: 10,
    loading: false,
    saveLoading: false, // 新增loading
    dataList: [], // 保司列表
    allData: {},
    userInfo: JSON.parse(localStorage.getItem('userInfo')) //用户信息
  }),
  mounted() {
    vm = this;
  },
  async activated() {
    vm = this;
    vm.queryCompanyList();
    vm.queryProductList();
    vm.getDataList();
  },
  methods: {
    // 查询所有保司
    queryCompanyList() {
      vm.$http({
        url: '/buz/insuranceCompany/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        vm.companyList = res.data;
      });
    },
    companyChange() {
      vm.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: { companyId: vm.formList.companyId }
      }).then(res => {
        vm.productList = res.data;
      });
    },
    // 查询所有产品
    queryProductList() {
      vm.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        vm.productList = res.data;
      });
    },

    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getDataList();
    },
    // 重置搜索
    resetSearch() {
      this.formList = {
        companyId: '',
        id: '',
        productType: ''
      };
      this.getDataList();
    },
    // 查询列表
    getDataList() {
      vm.loading = true;
      let params = {
        id: vm.formList.id,
        companyId: vm.formList.companyId, //保司id
        productType: vm.formList.productType, //产品类型
        pageSize: vm.pageSize,
        pageNo: vm.pageNo,
        ascs: '',
        descs: ''
      };
      for (var key in params) {
        if (params[key] === '') {
          delete params[key];
        }
      }
      vm.$http({
        url: '/buz/product/read/page',
        type: 'post',
        data: params
      })
        .then(res => {
          vm.loading = false;
          window.scrollTo(0, 0);
          vm.dataList = res.data;
          vm.allData = res;
        })
        .catch(e => {
          vm.loading = false;
        });
    },
    // 页面切换
    pageChange(index) {
      vm.pageNo = index;
      vm.getDataList();
    },
    //详情
    toDetailPage(row) {
      this.$router.push({
        path: '/operate/productManage/product/details/productDeatail',
        query: {
          name: row.name,
          companyName: row.companyName,
          id: row.id,
          productType: row.productType
        }
      });
    },
    toCommission(row) {
      this.$router.push({
        path: this.isIFA ? '/operate/productManage/product/details/productCommissionIFA' : '/operate/productManage/product/details/productCommission',
        query: {
          name: row.name,
          id: row.id,
          code: row.code
        }
      });
    },
    downloadFile(row) {
      this.$notice.inquiry(`是否下载该产品全部文件资料?`).then(() => {
        this.$units.downloadFile('/buz/product/info/download', { productId: row.id }, 'GET');
      });
    },
    //导出数据
    handleExport() {
      vm.$units.downloadFile('/buz/product/export', vm.formList, 'POST');
    }
  }
};
</script>
<style lang="scss" scoped>
@import './product';
</style>
